import { render, staticRenderFns } from "./recruitment-sidebar.vue?vue&type=template&id=61ba4229&scoped=true"
import script from "./recruitment-sidebar.vue?vue&type=script&lang=js"
export * from "./recruitment-sidebar.vue?vue&type=script&lang=js"
import style0 from "./recruitment-sidebar.vue?vue&type=style&index=0&id=61ba4229&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba4229",
  null
  
)

export default component.exports